import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-app-verification-report',
  templateUrl: './app-verification-report.component.html',
  styleUrls: ['./app-verification-report.component.scss']
})
export class AppVerificationReportComponent implements OnInit {

  constructor(
    private route: ActivatedRoute, 
    private cryptoJsService: CryptoJsService, 
    private router: Router,
    private activityRecordService: ActivityRecordService
    ) { }


  items: any[];
  autoId: any;
  appId: any;

  activeItem: any;
  userID: any;

  ngOnInit() {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;


    let parentRoute = this.router.url.split('/')[1];
    this.route.queryParams
      .subscribe(params => {
        this.autoId = params.autoId;
        this.appId = params.appId;
        this.items = [
          { label: 'Month Wise', routerLink: `/${parentRoute}/report/app-verification/month-wise`},
          { label: 'District Wise', routerLink: `/${parentRoute}/report/app-verification/district-wise` },
          { label: 'User Wise', routerLink: `/${parentRoute}/report/app-verification/user-wise` },
          { label: 'Vendor Wise',routerLink: `/${parentRoute}/report/app-verification/vendor-wise` },
          
        ];
      }
      );

  }

}
